import { ReactNode } from "react";
import { Sidebar } from "@/components/Sidebar";
import { useAuth } from "@/contexts/AuthContext";
import { SidebarProvider, useSidebar } from "@/contexts/SidebarContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

interface AppLayoutProps {
  children: ReactNode;
  showSidebar?: boolean;
}

function AppLayoutContent({ children, showSidebar = true }: AppLayoutProps) {
  const { profile } = useAuth();
  const { collapsed } = useSidebar();
  const isMobile = useIsMobile();

  // Simple role: just admin or regular user
  const isAdmin = profile?.isAdmin || profile?.roles?.includes("admin") || false;

  if (!showSidebar) {
    return <>{children}</>;
  }

  // Collapsed = 56px (w-14), Expanded = 192px (w-48)
  const marginLeft = isMobile ? "ml-0" : (collapsed ? "ml-14" : "ml-48");

  return (
    <div className="h-screen bg-background overflow-hidden">
      <Sidebar isAdmin={isAdmin} />
      <div
        className={cn(
          "h-screen overflow-y-auto transition-all duration-200",
          marginLeft
        )}
      >
        {children}
      </div>
    </div>
  );
}

export const AppLayout = ({ children, showSidebar = true }: AppLayoutProps) => {
  return (
    <SidebarProvider>
      <AppLayoutContent showSidebar={showSidebar}>
        {children}
      </AppLayoutContent>
    </SidebarProvider>
  );
};
